<script setup lang="ts">
const props = defineProps<{
	images: string[];
}>();

const previewImages = computed(() => props.images.slice(0, 3));
</script>

<template>
	<div
		v-if="previewImages.length"
		class="flex items-start drop-shadow-[0_2px_3px_rgba(0,0,0,0.15)]"
		aria-hidden="true"
	>
		<div
			v-for="(image, index) in previewImages"
			:key="`${image}-${index}`"
			class="-mr-1 size-10 overflow-hidden rounded-full border-[1.25px] border-white last:mr-0"
		>
			<NuxtImg
				:src="image"
				alt=""
				class="size-full object-cover"
				width="80"
				height="80"
				sizes="40px"
				format="webp"
				quality="80"
				loading="lazy"
			/>
		</div>
	</div>
</template>
